import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import { isSameReligion, normaliseReligion } from 'src/util/religion';

const ReligionInput = ({
  options = [],
  value,
  onChange,
  disabled = false,
  label = 'Religion',
  size
}) => {
  const selected = normaliseReligion(value);
  const resolvedOptions = React.useMemo(() => {
    if (!selected) return options;
    return options.some((o) => isSameReligion(o, selected))
      ? options
      : [...options, selected];
  }, [options, selected]);

  return (
    <Autocomplete
      options={resolvedOptions}
      value={selected}
      disabled={disabled}
      size={size}
      autoHighlight
      getOptionLabel={(option) => option?.display || ''}
      isOptionEqualToValue={isSameReligion}
      onChange={(_event, next) => onChange(normaliseReligion(next))}
      renderOption={(optionProps, option) => {
        const { key, ...rest } = optionProps;
        return (
          <Box component="li" key={key} {...rest}>
            <Typography variant="body2" noWrap>
              {option.display}
            </Typography>
          </Box>
        );
      }}
      renderInput={({ slotProps: inputSlotProps, ...params }) => (
        <TextField
          {...params}
          variant="outlined"
          fullWidth
          sx={{
            '& .MuiAutocomplete-input': { paddingRight: '56px !important' }
          }}
          slotProps={{
            ...inputSlotProps,
            htmlInput: {
              ...inputSlotProps?.htmlInput,
              'aria-label': t(label) || label,
              title: selected?.display || ''
            }
          }}
        />
      )}
    />
  );
};

export default ReligionInput;
